// extracted by mini-css-extract-plugin
export var barContainer = "_y-0";
export var extraThin = "_y-3";
export var fillBar = "_y-6";
export var fillContainer = "_y-4";
export var overflow = "_y-8";
export var overflowContainer = "_y-5";
export var regular = "_y-7";
export var thick = "_y-1";
export var thin = "_y-2";